"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5481],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 57613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ LinkCardList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32125);

var LinkCardList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LinkCardList",
  componentId: "sc-1coeyv8-0"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(316px,max-content));justify-content:center;gap:46px;@media screen and (max-width:1047px){gap:22px;}"]);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 13168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ SpAccordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Line__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var SpAccordion = function SpAccordion(_ref) {
  var title = _ref.title,
      children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var id = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Button, {
      onClick: function onClick() {
        return setIsExpand(function (prev) {
          return !prev;
        });
      },
      "aria-expanded": isExpand,
      "aria-controls": id,
      children: [title, isExpand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CloseIcon, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(OpenIcon, {})]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SpLine, {
      color: "grey",
      weight: 1,
      direction: "horizon"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Content, {
      id: id,
      children: children
    })]
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SpAccordion__Wrapper",
  componentId: "sc-1h04sez-0"
})(["@media screen and (max-width:1047px){width:100%;background:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var Button = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "SpAccordion__Button",
  componentId: "sc-1h04sez-1"
})(["display:none;@media screen and (max-width:1047px){font-size:16px;font-weight:bold;width:100%;padding:15px 12px 16px;display:flex;align-items:center;justify-content:space-between;color:", ";background:", ";border:none;border-radius:8px;&[aria-expanded='true']{border-bottom-left-radius:0;border-bottom-right-radius:0;}&[aria-expanded='false'] ~ div{height:0;padding-top:0;padding-bottom:0;opacity:0;overflow:hidden;pointer-events:none;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var SpLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Line__WEBPACK_IMPORTED_MODULE_2__/* .Line */ .x).withConfig({
  displayName: "SpAccordion__SpLine",
  componentId: "sc-1h04sez-2"
})(["display:none;@media screen and (max-width:1047px){display:block;margin:0 12px;}"]);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SpAccordion__Content",
  componentId: "sc-1h04sez-3"
})(["height:100%;@media screen and (max-width:1047px){transition:0.3s;height:auto;padding:16px 12px;border-top-right-radius:0;border-top-left-radius:0;}"]);
var OpenIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdAdd */ .x06).withConfig({
  displayName: "SpAccordion__OpenIcon",
  componentId: "sc-1h04sez-4"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var CloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdRemove */ .eqC).withConfig({
  displayName: "SpAccordion__CloseIcon",
  componentId: "sc-1h04sez-5"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 3319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-i66uaa-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-i66uaa-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-i66uaa-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-i66uaa-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 79794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ DownloadZipButton; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var DownloadZipButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "DownloadZipButton",
  componentId: "sc-11689qs-0"
})(["> button{display:inline-flex;padding:11px 16px 13px 20px;justify-content:center;align-items:center;gap:12px;height:42px;background:#ffffff;color:", ";border:1px solid ", ";border-radius:25px;box-sizing:border-box;@media screen and (max-width:1047px){padding:2px 18px 4px;height:32px;font-size:13px;}> svg{width:20px;height:18px;flex-shrink:0;fill:", ";}> span:first-of-type{text-align:center;font-size:16px;font-weight:500;line-height:1;letter-spacing:0.64px;}> span:nth-of-type(2){color:", ";font-size:13px;font-weight:500;line-height:1;letter-spacing:0.52px;}}&:hover > button{background-color:", ";border-color:", ";color:#ffffff;> svg{fill:#ffffff;}> span{color:#ffffff;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);

/***/ }),

/***/ 82319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/utils/enroutes.ts
var enroutes = __webpack_require__(9058);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/elements/SpAccordion/index.tsx
var SpAccordion = __webpack_require__(13168);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/IrSiteMap.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var SiteLink = function SiteLink(_ref) {
  var name = _ref.name,
      path = _ref.path,
      newWindow = _ref.newWindow;

  var link = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
    href: path,
    target: newWindow ? '_blank' : undefined,
    rel: newWindow ? 'noopener noreferrer' : undefined,
    children: name
  });

  if (path.endsWith('/ir/financial/chart/')) return link;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: path,
    passHref: true,
    children: link
  });
};

var IrSiteMap = function IrSiteMap(_ref2) {
  var parent = _ref2.parent,
      subdirectories = _ref2.subdirectories,
      _ref2$isLast = _ref2.isLast,
      isLast = _ref2$isLast === void 0 ? false : _ref2$isLast;

  if (isLast) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
      title: parent.name,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FullBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
          children: parent.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
          color: "grey",
          weight: 1,
          direction: "horizon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
          direction: "row",
          children: subdirectories.map(function (site) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
            }, site.path);
          })
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
    title: parent.name,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
        children: parent.path ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: parent.path,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
            children: parent.name
          })
        }) : parent.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 14
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
        color: "grey",
        weight: 1,
        direction: "horizon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
        direction: "column",
        children: subdirectories.map(function (site) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
          }, site.name);
        })
      })]
    })
  });
};
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__Box",
  componentId: "sc-pz1tvd-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;padding:26px 20px 32px;@media screen and (max-width:1047px){width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FullBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__FullBox",
  componentId: "sc-pz1tvd-1"
})(["width:1040px;padding:26px 20px 32px;background:", ";border-radius:8px;display:flex;justify-content:space-between;align-items:center;@media screen and (max-width:1047px){display:block;width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var PcLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "IrSiteMap__PcLine",
  componentId: "sc-pz1tvd-2"
})(["@media screen and (max-width:1047px){display:none;}"]);
var ParentName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__ParentName",
  componentId: "sc-pz1tvd-3"
})(["font-size:20px;font-weight:700;line-height:120%;@media screen and (max-width:1047px){display:none;}"]);
var SubdirectoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "IrSiteMap__SubdirectoryList",
  componentId: "sc-pz1tvd-4"
})(["display:flex;row-gap:16px;column-gap:50px;flex-direction:", ";", " > li{font-size:16px;line-height:120%;}@media screen and (max-width:1047px){gap:14px;flex-direction:column;> li{font-size:14px;}}"], function (_ref3) {
  var direction = _ref3.direction;
  return direction;
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'row' && 'margin-right: 120px;';
});
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "IrSiteMap__StyledLink",
  componentId: "sc-pz1tvd-5"
})(["color:", ";display:block;width:100%;&:hover{text-decoration:underline;color:", ";}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/index.tsx





var IrSiteMapLink = function IrSiteMapLink() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "regular",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_MANAGE_ROUTE.path */.Xp.path,
          name: enroutes/* IR_MANAGE_ROUTE.name */.Xp.name
        },
        subdirectories: enroutes/* IR_MANAGE_ROUTE.subdirectories */.Xp.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_GOVERNANCE_ROUTE.path */.by.path,
          name: enroutes/* IR_GOVERNANCE_ROUTE.name */.by.name
        },
        subdirectories: enroutes/* IR_GOVERNANCE_ROUTE.subdirectories */.by.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_FINANCIAL_ROUTE.path */.Oh.path,
          name: enroutes/* IR_FINANCIAL_ROUTE.name */.Oh.name
        },
        subdirectories: enroutes/* IR_FINANCIAL_ROUTE.subdirectories */.Oh.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "high",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_LIBRARY_ROUTE.path */.C_.path,
          name: enroutes/* IR_LIBRARY_ROUTE.name */.C_.name
        },
        subdirectories: enroutes/* IR_LIBRARY_ROUTE.subdirectories */.C_.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_STOCK_ROUTE.path */.aQ.path,
          name: enroutes/* IR_STOCK_ROUTE.name */.aQ.name
        },
        subdirectories: enroutes/* IR_STOCK_ROUTE.subdirectories */.aQ.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
      parent: {
        name: enroutes/* IR_OTHER_ROUTE.name */.yE.name
      },
      subdirectories: enroutes/* IR_OTHER_ROUTE.subdirectories */.yE.subdirectories,
      isLast: true
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__Wrapper",
  componentId: "sc-wp9cdp-0"
})(["display:flex;flex-direction:column;gap:46px;@media screen and (max-width:1047px){gap:14px;}"]);
var SiteMapList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__SiteMapList",
  componentId: "sc-wp9cdp-1"
})(["display:flex;gap:46px;height:100%;@media screen and (max-width:1047px){flex:1;flex-direction:column;gap:14px;}"]);
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/Footer.tsx





var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
      children: "IR Site Map"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 60
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMapLink, {})]
  });
};
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/index.tsx





var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 140
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__Container",
  componentId: "sc-baigr5-0"
})(["width:1040px;margin:94px auto 130px;@media screen and (max-width:1047px){margin:40px auto 120px;width:100%;padding:0 20px;}"]);

/***/ }),

/***/ 98259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useMpocketScript; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// 修正案1

console.log('4');
var useMpocketScript = function useMpocketScript(src) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState2[0],
      setError = _useState2[1]; // エラー状態をstringまたはnullで初期化


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (false) {} // SSR対策

    var loadScript = /*#__PURE__*/function () {
      var _ref = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var scriptElement = document.createElement('script');
                  var srcWithTime = src;
                  var time = new Date().getTime();

                  if (srcWithTime.includes('?')) {
                    srcWithTime += "&_t=".concat(time);
                  } else {
                    srcWithTime += "?_t=".concat(time);
                  }

                  scriptElement.src = srcWithTime;
                  scriptElement.async = true;
                  console.log('scriptElement.src:', scriptElement.src);
                  document.body.appendChild(scriptElement); // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);

                  // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);
                  var existingScript = document.querySelector("script[src*=\"".concat(src, "\"]"));

                  if (existingScript) {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u65E2\u306B\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u3059: ".concat(src));
                    resolve(existingScript);
                    return;
                  } else {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3001\u8FFD\u52A0\u3057\u307E\u3059: ".concat(src));
                  } // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;


                  // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;
                  scriptElement.onload = function () {
                    console.log('マジカルポケットの外部スクリプトが読み込まれました。');
                    console.log('scriptElement.src:', scriptElement.src);
                    setIsLoaded(true);
                    resolve(scriptElement);
                  };

                  scriptElement.onerror = function () {
                    var errorMessage = 'マジカルポケットの外部スクリプトの読み込みに失敗しました。';
                    console.error(errorMessage);
                    setError(errorMessage); // カスタムエラーメッセージをセット

                    // カスタムエラーメッセージをセット
                    reject(new Error(errorMessage));
                  }; // document.body.appendChild(scriptElement);


                  // document.body.appendChild(scriptElement);
                  console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304CDOM\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F: ".concat(src));
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                setError(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function loadScript() {
        return _ref.apply(this, arguments);
      };
    }();

    loadScript();
  }, [src]);
  return {
    isLoaded: isLoaded,
    error: error
  };
};
/*
import { useEffect, useState } from 'react';

export const useMpocketScript = (src: string) => {
  const [isLoaded, setIsLoaded] = useState(false);  // スクリプト(js)読込状況の確認用
  const [error, setError] = useState<string | null>(null);  // エラーメッセージ格納用

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR対策とスクリプト読み込みフラグ確認

    const loadScript = () => {
      //Promiseを利用した非同期処理
      //各種読み込み状態・処理状態に応じた処理を行うため、Promiseを使用
      return new Promise((resolve, reject) => {
        // 既に同じsrcのスクリプトが存在するか確認
        const existingScript = document.querySelector(`script[src="${src}"]`);  

        if (existingScript) { // 存在している場合
          console.log(`スクリプトが既にページに存在します: ${src}`);
          setIsLoaded(true);
          resolve(existingScript);
          return;
        }
        
        // 新しいスクリプト要素の作成
        const scriptElement = document.createElement('script');
        scriptElement.src = src;
        scriptElement.async = true; // 非同期での読込。可読性重視のため、asyncを採用

        // スクリプトの読込成功時
        scriptElement.onload = () => {
          console.log('外部スクリプトが読み込まれました。');
          setIsLoaded(true);
          resolve(scriptElement);
        };

        // スクリプトの読込失敗時
        scriptElement.onerror = () => {
          const errorMessage = '外部スクリプトの読み込みに失敗しました。';
          console.error(errorMessage);
          setError(errorMessage);
          reject(new Error(errorMessage));  //エラーで拒否
        };

        // スクリプトをDOMに追加
        const appendScript = () => {
          if (document.body) {
            document.body.appendChild(scriptElement);
            console.log(`スクリプトがDOMに追加されました: ${src}`);
          } else {
            console.error('document.bodyが存在しません。スクリプトの追加に失敗しました。');
            reject(new Error('document.bodyが存在しません。スクリプトの追加に失敗しました。')); //エラーで拒否
          }
        };

        // ドキュメントの準備状態に応じて作業を変更
        if (document.readyState === 'loading') {   // ドキュメントが読み込み中の場合
          document.addEventListener('DOMContentLoaded', appendScript);
        } else {  // ドキュメントが読み込み済みの場合
          appendScript();
        }
      });
    };

    // スクリプトを同期的に読込
    //　可読性重視、ハンドリングの容易さを重視しての、async選択
    const syncLoadScript = async () => {
      try {
        await loadScript(); // スクリプトの読み込み待ち
      } catch (error) { // エラーが発生時
        setError(error instanceof Error ? error.message : String(error));
      }
    };

    syncLoadScript(); // スクリプトの同期読込
  }, [src]);

  return { isLoaded, error };
};

*/

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);